// Landing animation

// $('#landing-animation-history').hide()
// $('.landing-hidden').show()
// $('#landing-animation-video')[0].play()
// $('#landing-animation-video').fadeIn(600)

// if(Cookies.get('seenAnimation')) {
//   $('#landing-animation-history').hide()
//   $('.landing-hidden').show()
//   $('#landing-animation-video')[0].play()
//   $('#landing-animation-video').fadeIn(600)
// } else {
//   $('html, body').css({
//     overflow: 'hidden',
//     height: '100%'
//   });

//   // Play logo reveal

//   $('#landing-logo img').addClass('landing_logo_open')

//   setTimeout(() => {
//     $('#landing-logo').fadeOut(600)
//     $('#landing-animation-video')[0].play()
//     $('#landing-animation-video').fadeIn(600)
//     finishedLandingAnimation()
//   }, 6000)

//   function finishedLandingAnimation() {
//     setTimeout(()=>{
//       $('.landing-hidden').fadeIn(800)
//       $('html, body').css({
//         overflow: 'auto',
//         height: 'auto'
//       });
//     },9000)
//   }
// }

// document.addEventListener('DOMContentLoaded', function() {
//   Cookies.set('seenAnimation', true, 7)
// }, false);

$(window).scrollTop();

$("#down-arrow").addClass("visible"); // Show down arrow at the start

// Add the 'landing_logo_open' class to the landing logo image
$("#landing-logo img").addClass("landing_logo_open");

// Allow scrolling and set the height of the page to its natural height
$("html, body").css({
  overflow: "auto",
  height: "auto",
});

// Flags to track whether the wait time has passed and the page has finished loading
let finishedWait = false;
let finishedLoad = false;

// After 4 seconds, set the 'finishedWait' flag to true and call the 'play' function
setTimeout(() => {
  finishedWait = true;
  play();
}, 4000);

// When the DOM has finished loading, set the 'finishedLoad' flag to true and call the 'play' function
document.addEventListener(
  "DOMContentLoaded",
  function () {
    finishedLoad = true;
    play();
  },
  false
);

// This function is responsible for the landing page animation sequence
function play() {
  // Call 'finishedLandingAnimation' to reveal hidden elements and allow scrolling
  finishedLandingAnimation();

  // Only proceed with the rest of the animation if the wait time has passed and the page has finished loading
  if (finishedWait && finishedLoad) {
    // Remove the 'landing_logo_open' class from the landing logo image
    $("#landing-logo img").removeClass("landing_logo_open");

    // After 1 second, start the fade-out animation for the landing logo
    setTimeout(function () {
      $("#landing-logo").fadeOut(600);
    }, 1000);

    // After 1.5 seconds, start the fade-in animation for the landing video
    setTimeout(() => {
      $("#landing-animation-video").fadeIn(1000);

      // Once the video is visible, start playing it after 500 milliseconds
      setTimeout(() => {
        $("#landing-animation-video")[0].play();
      }, 500);
    }, 1500);
  }
}

// This function reveals hidden elements and allows scrolling
function finishedLandingAnimation() {
  // Show the hidden elements and then start a fade-in animation
  $(".landing-hidden").show;
  $(".landing-hidden").fadeIn(1200); // Duration of the fade in for menu bar and arrow

  // Allow scrolling and set the height of the page to its natural height
  $("html, body").css({
    overflow: "auto",
    height: "auto",
  });
}

// This function scrolls the page to a given element
function scrollToElement(id) {
  // Log which element we're scrolling to
  console.log("scrollTo called with id: " + id);

  // Animate the scroll to the top of the given element
  $("html, body").animate(
    {
      scrollTop: $(id).offset().top,
    },
    1000
  );
}

// When the down arrow is clicked, end the landing animation and scroll to the section below the home section
$("#down-arrow").click(function () {
  finishedLandingAnimation();
  scrollToElement("#belowHome");
});

let cartHasItems = false;
$(".price").click(() => {
  if (cartHasItems) {
    openCart();
  } else {
    scrollTo("#buy-section");
  }
});

// Newsletter

// $.post(window.Shopify.routes.root + 'cart/clear.js')

$(".add-to-cart").click((event) => {
  addToCart($(event.currentTarget).data("product")).then(() => {
    openCart();
  });
});

function addToCart(id, quantity = 1) {
  return new Promise((resolve, reject) => {
    const purchase = {
      items: [
        {
          id: id,
          quantity: quantity,
        },
      ],
    };

    $.ajax({
      type: "POST",
      url: window.Shopify.routes.root + "cart/add.js",
      data: purchase,
    }).always((data) => {
      console.log("finished");
      if (data.status == 200) {
        resolve();
      } else {
        console.log(data);
        const errorMessage = JSON.parse(data.responseText).description;
        console.log(errorMessage);
        reject();
      }
    });
  });
}

var formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
});

function openCart() {
  console.log("OPEN CART");
  $("body").addClass("no-scroll");
  getCart().then((cart) => {
    $("#cart").show();
    formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: cart.currency,
      minimumFractionDigits: 2,
    });
    setTimeout(() => {
      $(".cart-background").addClass("cart-background-active");
      $(".cart").addClass("cart-active");
      updateButton(cart.item_count);
    }, 100);
    $("#cart-total").html(formatter.format(cart.total_price / 100));
    for (let i = 0; i < cart.items.length; i++) {
      const el = cart.items[i];
      $("#cart-items").append(`
        <li>
          <div class="cart-item-name"><p>${el.title}</p></div>
          <div class="cart-item-quantity">
            <input type="number" value="${el.quantity}" min="0" data-product="${
        el.id
      }">
          </div>
          <div class="cart-item-price"><p>${formatter.format(
            el.price / 100
          )}</p></div>
        </li>
      `);
    }

    $(".cart-item-quantity input").on("input", (event) => {
      updateCart(
        $(event.currentTarget).data("product"),
        $(event.currentTarget).val()
      ).then(() => {
        getCart().then((newcart) => {
          updateButton(newcart.item_count);
          $("#cart-total").html(formatter.format(newcart.total_price / 100));
        });
      });
    });
  });
}

function updateCart(id, quantity = 1) {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "POST",
      url: window.Shopify.routes.root + "cart/update.js",
      data: {
        updates: {
          [`${id}`]: quantity,
        },
      },
    }).always((data) => {
      if (data.status == 200) {
        resolve();
      } else {
        console.log(data);
        const errorMessage = JSON.parse(data.responseText).description;
        console.log(errorMessage);
        reject();
      }
    });
  });
}

function getCart() {
  return new Promise((resolve, reject) => {
    jQuery.getJSON("/cart.js", (cart) => {
      resolve(cart);
    });
  });
}

function updateButton(number) {
  if (number > 0) {
    cartHasItems = true;
    $(".price p").html(`cart ${number}`);
  } else {
    cartHasItems = false;
    $(".price p").html(`buy`);
  }
}

getCart().then((cart) => {
  updateButton(cart.item_count);
});

$(".cart-background, .cart-header-quantity img").click(() => {
  $(".cart-background").removeClass("cart-background-active");
  $(".cart").removeClass("cart-active");
  $("body").removeClass("no-scroll");
  setTimeout(() => {
    $("#cart").hide();
    $("#cart-items").html("");
  }, 500);
});
